'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dialogClose = require('./dialog-close.component');

var _dialogClose2 = _interopRequireDefault(_dialogClose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.dialogClose', []).component('dialogClose', _dialogClose2.default).name;


// WEBPACK FOOTER //
// ./components/app/common/dialog-close/dialog-close.module.js